import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 19l3.332 -11.661","key":"svg-0"}],["path",{"d":"M16 5l2.806 9.823","key":"svg-1"}],["path",{"d":"M12 8v-2","key":"svg-2"}],["path",{"d":"M12 13v-1","key":"svg-3"}],["path",{"d":"M12 18v-2","key":"svg-4"}],["path",{"d":"M3 3l18 18","key":"svg-5"}]]

const IconRoadOff = createReactComponent('outline', 'road-off', 'RoadOff', __iconNode);

export default IconRoadOff;